import {Breakpoint} from "@mui/material";
import {Theme} from "@mui/system";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";


export const hideForBreakpoint = (breakpoint: string, responsiveSettings: any) => {
    // Find the responsive setting property whose suffix matches the current breakpoint
    const responsivePropertySuffix = responsiveSettings && Object.keys(responsiveSettings)
        .find(prop => prop.slice(-2).toLowerCase() === breakpoint.toLowerCase());
    // Check if the responsive property suffix exists and if it's true
    return responsivePropertySuffix && responsiveSettings[responsivePropertySuffix];
}

export const useBreakpoints = (): Breakpoint => {
    const theme: Theme = useTheme()
    const keys: readonly Breakpoint[] = [...theme.breakpoints.keys]
    return (
        keys.reduce((output: Breakpoint | null, key: Breakpoint) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const matches = useMediaQuery(theme.breakpoints.up(key))
            return matches ? key : output
        }, null) ?? 'xs'
    )
}
